import Mappable from './mappable';
import { standardDateStamp } from '../../utils/dates';

export default class extends Mappable {
  constructor(json) {
    const { id, address, coordinates, name } = json;
    super(id, address || name, coordinates);
    this.init(json);
  }

  get mappableType() {
    return 'Service Request';
  }

  get createdAtDateStamp() {
    return standardDateStamp(this.createdAt);
  }

  get types() {
    return ['Service Request'];
  }

  get badgeSrc() {
    return require(`@/assets/img/map/${
      this.hasSprayForm
        ? 'badge-spray-reminder-active'
        : 'badge-service-request-active'
    }.svg`);
  }

  get pinSrc() {
    return require(`@/assets/img/map/${
      this.hasSprayForm
        ? 'pin-spray-request-active'
        : 'pin-service-request-active'
    }.svg`);
  }

  get hasSprayForm() {
    return this.adulticideIds.length > 0;
  }

  init(data) {
    const thisOriginal = {
      ...this,
    };
    Object.assign(this, data, thisOriginal);
    this.createdAt = new Date(this.createdAt);
    const closedByOffice = this.status
      .toLowerCase()
      .includes('closed by office');
    const upcomingInspectionDate =
      !this.inspectionDate || new Date(this.inspectionDate) >= new Date();
    this.isActive = !closedByOffice && upcomingInspectionDate;
    this.isScheduled = this.isActive;
  }

  hasAnyType(types) {
    return types.includes(
      this.hasSprayForm ? 'Spray Reminder' : 'Service Request'
    );
  }

  getLatestActivityDate() {
    return this.createdAt;
  }
}
